<template>
  <b-tabs>
    <div class="dropdown-header-notify d-flex">
      <h6 class="dropdown-header-notify_title mb-0 mr-auto">
        {{ $t("notifications") }}
      </h6>
      <!-- <div> -->
      <!-- <feather-icon
          size="20"
          @click="isShowTitle = !isShowTitle"
          icon="MoreVerticalIcon"
          class="icon-mark cursor-pointer"
        /> -->
      <!-- </div> -->
      <div v-click-outside="() => (isShowTitle = false)">
        <feather-icon
          size="20"
          @click="isShowTitle = !isShowTitle"
          icon="MoreVerticalIcon"
          class="icon-mark cursor-pointer"
        />
        <div
          v-show="isShowTitle"
          class="title-more-notify"
          @click="handReadAll"
        >
          <feather-icon
            size="18"
            icon="CheckIcon"
            class="icon-mark cursor-pointer"
          />
          {{ $t("MarkAllAsRead") }}
        </div>
      </div>
    </div>
    <b-card class="dropdown-card">
      <b-overlay
        :show="isFilter"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <div>
          <div class="icon-search-wrapper mx-auto">
            <fieldset class="form-group">
              <div>
                <div role="group" class="input-group input-group-merge">
                  <input
                    id="icons-search"
                    type="text"
                    v-model.trim="searchQuery"
                    v-on:keyup.enter="getConfigNotifyFist"
                    placeholder="Search"
                    class="form-control"
                  />
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14px"
                        height="14px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-search"
                      >
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div v-if="notifications.length == 0 && searchQuery">
            <p class="my-3 text-center">
              <feather-icon
                icon="SearchIcon"
                size="18"
                class="mr-50"
                style="margin-top: -3px"
              />
              No messages matched your search.
            </p>
          </div>
          <div v-else class="app-action">
            <div class="header-action-notify">
              <b-badge variant="primary" @click="loadAllReadOrUnReadPage(-1)"
                >All</b-badge
              >
              <b-badge
                variant="primary"
                class="ml-2"
                @click="loadAllReadOrUnReadPage(0)"
                >Unread</b-badge
              >
              <b-badge
                variant="primary"
                class="ml-2"
                @click="loadAllReadOrUnReadPage(1)"
                >Read</b-badge
              >
            </div>
          </div>
          <div v-if="notifications.length == 0 && readed != -1">
            <p class="my-3 text-center">
              <feather-icon
                icon="SearchIcon"
                size="18"
                class="mr-50"
                style="margin-top: -3px"
              />
              No messages matched your search.
            </p>
          </div>
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="email-user-list scroll-area"
          >
            <!-- @click="updateNotificationViewData(notification)" -->

            <ul class="email-media-list" style="padding: 0">
              <b-media
                v-for="notification in notifications"
                :key="notification.id"
                tag="li"
                no-body
                class="mail-read"
              >
                <!-- <b-media-aside class="media-left mr-50">
                  <div class="user-action">
                    <b-form-checkbox
                      :checked="selectedNotifications.includes(notification.id)"
                      @change="toggleSelectedMail(notification.id)"
                      @click.native.stop
                    />
                  </div>
                </b-media-aside> -->

                <b-media-body>
                  <div class="mail-details">
                    <div class="mail-items d-flex justify-content-between">
                      <h5
                        class="mb-25"
                        @click="updateNotificationViewData(notification)"
                        :style="
                          notification.readed == 0 ? 'font-weight:600' : ''
                        "
                      >
                        {{ notification.notify_config_name }}
                      </h5>
                    </div>
                    <div>
                      <feather-icon
                        size="15"
                        @click="
                          shownItemById(
                            notification.id,
                            !notification.shownPage
                          )
                        "
                        icon="MoreVerticalIcon"
                        :class="[
                          'icon-circle cursor-pointer',
                          notification.readed == 0
                            ? 'active-notify'
                            : 'bg-white rounded-circle d-none',
                        ]"
                      />
                      <div
                        v-show="notification.shownPage"
                        class="drop-more-vertical"
                      >
                        <div
                          class="drop-more-vertical_mark"
                          @click="handMarkUnread(notification.id)"
                        >
                          <feather-icon
                            size="20"
                            icon="CheckIcon"
                            class="icon-mark cursor-pointer"
                          />
                          {{ $t("MarkUnread") }}
                        </div>
                        <div
                          class="drop-more-vertical_remove"
                          @click="handDeleteByID(notification.id)"
                        >
                          <feather-icon
                            size="20"
                            icon="XIcon"
                            class="icon-mark cursor-pointer"
                          />
                          {{ $t("Remove") }}
                        </div>
                      </div>
                      <!-- <div class="mail-meta-item">
                      <span class="mail-date">{{
                        prettyDate(notification.created_date)
                      }}</span>
                    </div> -->
                    </div>
                  </div>

                  <div
                    class="mail-message"
                    @click="updateNotificationViewData(notification)"
                  >
                    <p class="text-truncate mb-0">
                      {{
                        filterTags(
                          $i18n.locale == "en"
                            ? notification.message
                            : notification.message_vn
                        )
                      }}
                    </p>
                  </div>
                  <small class="text-small">{{
                    notification.created_date
                  }}</small>
                </b-media-body>
              </b-media>
            </ul>
            <scroll-loader
              :loader-method="getNotifyList"
              :loader-disable="disable"
            >
            </scroll-loader>
          </vue-perfect-scrollbar>
        </div>
      </b-overlay>
    </b-card>
  </b-tabs>
</template>

<script>
import { BButton, BRow, BCol, BCard, BFormCheckbox } from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { filterTags, formatDateToMonthShort } from "@core/utils/filter";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ClickOutside from "vue-click-outside";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BFormCheckbox,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
    ClickOutside,
  },
  props: {
    notificationData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowTitle: false,

      userData: JSON.parse(localStorage.getItem("userData")),
      formatDateToMonthShort,
      filterTags,
      disable: false,
      page: 1,
      isFilter: false,
      pageSize: 30,
      totalMeta: 0,
      localOptions: {},
      searchQuery: "",
      selectedNotifications: [],
      notify: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
      },
      fields: [
        {
          key: "name",
          sortable: false,
          label: "Name",
        },
        {
          key: "web",
          sortable: false,
          label: "web",
        },
        {
          key: "email",
          sortable: false,
          label: "email",
        },
        // {
        //   key: "sms",
        //   sortable: false,
        //   label: "sms",
        // },
      ],

      tabActive: 1,
      readed: -1,
    };
  },
  watch: {
    searchQuery(first, old) {
      if (this.searchQuery == "" && first != old) {
        this.selectedNotifications = [];
        this.isFilter = true;
        this.page = 1;
        this.readed = -1;
        this.$store.commit("notify/RESET");
        this.getConfigNotifyFist();
      }
    },
  },
  computed: {
    notifications() {
      return this.$store.state.notify.notifications;
    },
    selectAllNotificationCheckbox() {
      return (
        this.notifications.length &&
        this.notifications.length === this.selectedNotifications.length
      );
    },
    isSelectAllNotificationCheckboxIndeterminate() {
      return (
        Boolean(this.selectedNotifications.length) &&
        this.notifications.length !== this.selectedNotifications.length
      );
    },
  },
  async mounted() {
    this.isFilter = true;
    this.$store.commit("notify/RESET");
    // this.getConfigNotifyFist();
  },
  methods: {
    loadAllReadOrUnReadPage(isReaded) {
      this.readed = isReaded;
      this.$store.dispatch("notify/GET_NOTIFY_BY_USER", {
        search: "",
        page: 1,
        pageSize: 30,
        readed: isReaded,
      });
    },

    handReadAll() {
      this.$store
        .dispatch("notify/UPDATE_NOTIFY", {
          ids: "",
          markAllAsRead: 1,
        })
        .then(() => {
          this.$store.commit("notify/RESET");
          this.$store.dispatch("notify/GET_NOTIFICATION");
          this.getConfigNotifyFist();
        });
    },
    handMarkUnread(id) {
      this.$store
        .dispatch("notify/UNREAD_NOTIFY", {
          ids: id,
          markAsUnRead: 1,
        })
        .then(() => {
          this.$store.commit("notify/RESET");
          this.$store.dispatch("notify/GET_NOTIFICATION");
          this.getConfigNotifyFist();
        });
    },
    handDeleteByID(id) {
      this.$store
        .dispatch("notify/DELETE_NOTIFY", {
          id: id,
        })
        .then(() => {
          this.$store.commit("notify/RESET");
          this.$store.dispatch("notify/GET_NOTIFICATION");
          this.getConfigNotifyFist();
        });
    },
    shownItemById(id, value) {
      return this.$store.commit("notify/SET_SHOWS_PAGE_BY_ID", { id, value });
    },

    updateNotificationViewData(notify) {
      this.$loading.show();
      if (notify.notify_config_code === "ACCOUNT_NEED_APPROVAL") {
        this.$router
          .replace({
            name: "approve-register",
          })
          .catch((error) => {});
        return;
      }

      if (notify.readed == 0) {
        this.$store
          .dispatch("notify/UPDATE_NOTIFY", {
            ids: notify.id.toString(),
            markAllAsRead: "0",
          })
          .then(() => {
            this.$store.commit("notify/SET_UPDATE_READ_BY_ID", notify.id);
          })
          .finally(() => {
            this.selectedNotifications = [];
            this.$store.dispatch("notify/GET_NOTIFICATION");
            this.$loading.hide();
          });
      }

      if (
        this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
      ) {
        if (
          this.$Utils.CONSTANTS.STATUS_WR1.BOOKING.split(",")
            .map(Number)
            .includes(notify.object_status)
        ) {
          //@todo here
          if (
            notify.notify_config_code === "BOOKING_HAS_BOOKING" ||
            notify.notify_config_code.includes("BOOKING") || notify.notify_config_code == "BOOKING_REQUEST_AN_UPDATE"
          ) {
            this.$store.commit("tabView/SET_OBJECT_TYPE", notify.notify_config_code);
            this.$router
              .push({
                name: "my-wr1-booking",
                params: {
                  idBooking: notify.object_id,
                },
              })
              .catch((error) => {});
            return;
          }
          this.$router.push({
            name: "my-wr1-booking",
            params: {
              idBooking: notify.object_id,
            },
          });
          
          this.$store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          this.$store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
          
        } else {
          this.$router.push({
            name: "my-wr1-quotation",
            params: {
              idQuo: notify.object_id,
            },
          });
          this.$store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          this.$store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
          
        }
      } else {
        if (
          notify.notify_config_code === "BOOKING_HAS_BOOKING" ||
          notify.notify_config_code.includes("BOOKING")
        ) {
          this.$router
            .push({
              name: "user-my-booking",
              params: {
                idBooking: notify.object_id,
              },
            })
            .catch((error) => {});
          return;
        }
        if (
          this.$Utils.CONSTANTS.STATUS_WR1.BOOKING.split(",")
            .map(Number)
            .includes(notify.object_status)
        ) {
          this.$store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          this.$store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
          this.$router.push({
            name: "user-my-booking",
            params: {
              idBooking: notify.object_id,
            },
          });
        } else {
          this.$store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          this.$store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
          this.$router.push({
            name: "user-my-quotation",
            params: {
              idQuo: notify.object_id,
            },
          });
        }
      }
    },

    selectAllCheckboxUpdate(val) {
      this.selectedNotifications = val
        ? this.notifications.map((notification) => notification.id)
        : [];
    },
    toggleSelectedMail(mailId) {
      const mailIndex = this.selectedNotifications.indexOf(mailId);

      if (mailIndex === -1) this.selectedNotifications.push(mailId);
      else this.selectedNotifications.splice(mailIndex, 1);
    },
    async getConfigNotifyFist() {
      const res = await this.$store.dispatch("notify/GET_NOTIFY_BY_USER", {
        search: this.searchQuery,
        page: 1,
        pageSize: this.pageSize,
        readed: this.readed,
      });
      this.isFilter = false;
      this.disable = res.meta.total < this.notifications.length;
    },
    async getNotifyList() {
      this.$loading.show();
      this.selectedNotifications = [];
      const res = await this.$store.dispatch("notify/GET_NOTIFY_BY_USER", {
        search: this.searchQuery,
        page: this.page++,
        pageSize: this.pageSize,
        pagination: true,
        readed: this.readed,
      });
      this.isFilter = false;
      this.$loading.hide();

      this.disable = res.meta.total <= this.notifications.length;
    },
    getConfigNotify() {
      this.$loading.show();

      useJwt
        .get("userNotifyConfig")
        .then((response) => {
          if (response.data.message == "success!") {
            this.notify = response.data.result.map((e) => {
              if ((e.web = 1)) {
                return e;
              }
            });
          }
        })
        .finally(() => this.$loading.hide());
    },
    moveSelectedNotificationsToFolder(type) {
      this.selectedNotifications = [];
      this.isFilter = true;
      this.page = 1;
      this.readed = type;
      this.$store.commit("notify/RESET");
      this.getConfigNotifyFist();
    },
    handOk() {
      this.$loading.show();
      var RoleIndex = [];
      this.notify.map((e) => {
        if (e.email == 1) {
          RoleIndex.push(e.email_id);
        }
        if (e.sms == 1) {
          RoleIndex.push(e.sms_id);
        }
        if (e.web == 1) {
          RoleIndex.push(e.web_id);
        }
      });
      useJwt
        .put("userNotifyConfig", { notifyConfigIds: RoleIndex.toString() })
        .then((response) => {
          if (response.data.message == "success!") {
            this.getConfigNotify();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyUpdated"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    prettyDate(time) {
      const data = time.split(/\/|\s/);
      var dateFormat = data.slice(0, 3).reverse().join("-") + " " + data[3];
      var date = new Date(
          (dateFormat || "").replace(/-/g, "/").replace(/[TZ]/g, " ")
        ),
        diff = (new Date().getTime() - date.getTime()) / 1000,
        day_diff = Math.floor(diff / 86400);

      if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31)
        return moment(dateFormat).format("DD-MM-YYYY HH:MM");

      return (
        (day_diff == 0 &&
          ((diff < 1 && "just now") ||
            (diff < 60 && "just now") ||
            (diff < 120 && "1 minute ago") ||
            (diff < 3600 && Math.floor(diff / 60) + " minutes ago") ||
            (diff < 7200 && "1 hour ago") ||
            (diff < 86400 && Math.floor(diff / 3600) + " hours ago"))) ||
        (day_diff == 1 && "Yesterday") ||
        (day_diff < 7 && day_diff + " days ago") ||
        (day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago")
      );
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-email.scss";
@import "~@core/scss/base/pages/account-notify.scss";
</style>
<style lang="scss">
.text-black {
  color: rgba(26, 24, 24, 0.768);
}
.notification-date {
  font-weight: 600;
}
// .app-action {
//   padding: 0.9rem 1.5rem;
//   border-bottom: 1px solid #ebe9f1;
//   background-color: #fff;
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: justify;
//   -ms-flex-pack: justify;
//   justify-content: space-between;
// }
.media-aside {
  display: flex;
  gap: 20px;
  align-self: center;
  align-items: center;

  &:hover {
    background: rgba(0, 0, 0, 0.049);
    border-radius: 1rem;
  }
}

.email-media-list li:not(:first-child) {
  border-top: 1px solid #ebe9f1;
}
.email-media-list li {
  cursor: pointer;
}
li.media {
  padding: 1.5rem;
  border-radius: 20px;
  margin-bottom: 13px;
  border: 2px solid #e2f2ef;
}
.mail-read:hover {
  background-color: #e2f2ef;
}
.mail-details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 0.55rem;
}

.email-media-list li.media:hover {
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
  -webkit-box-shadow: 0 3px 10px 0 #ebe9f1;
  box-shadow: 0 3px 10px 0 #ebe9f1;
}

.mail-date {
  color: #b9b9c3;
  font-size: 0.857rem;
}

.disabled-select {
  -webkit-user-select: none;
  user-select: none;
}
</style>
